// extracted by mini-css-extract-plugin
export default {"TenantContactBlock":"UserInfoBlock_TenantContactBlock__mhhb+"};